(function () {
  "use strict";

  var STORAGE_KEY = "alunir_attribution_v1";
  var VERSION = 1;
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var TEXT_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  var CLICK_KEYS = ["fbadid", "fbclid", "gclid", "wbraid", "gbraid", "ttclid", "msclkid"];
  var PAID_MEDIA = {
    cpc: true,
    ppc: true,
    paid: true,
    paid_social: true,
    paidsocial: true,
    display: true,
    retargeting: true,
  };
  var pendingTouch = captureTouch();

  function clean(value, maxLength) {
    if (!value) return null;
    var normalized =
      String(value)
        .replace(/[\u0000-\u001f\u007f]/g, "")
        .trim()
        .slice(0, maxLength || 500) || null;
    if (!normalized) return null;
    if (/\{\{\s*[^{}]+\s*\}\}|%7b%7b[^%]*(?:%7d%7d)/i.test(normalized)) return null;
    return normalized;
  }

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return (
        !!privacy &&
        typeof privacy.marketingAllowed === "function" &&
        privacy.marketingAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function isAlunirUrl(value) {
    try {
      var hostname = new URL(value).hostname.toLowerCase();
      return hostname === "alunir.ch" || hostname.slice(-10) === ".alunir.ch";
    } catch (error) {
      return false;
    }
  }

  function captureTouch() {
    try {
      var page = new URL(window.location.href);
      var now = new Date();
      var touch = {
        captured_at: now.toISOString(),
        expires_at: new Date(now.getTime() + TTL_MS).toISOString(),
        landing_page: page.origin + page.pathname,
        referrer_host: null,
      };
      TEXT_KEYS.concat(CLICK_KEYS).forEach(function (key) {
        var value = clean(page.searchParams.get(key));
        if (value) touch[key] = value;
      });
      if (document.referrer) {
        var referrer = new URL(document.referrer);
        if (referrer.hostname && referrer.hostname !== page.hostname) {
          touch.referrer_host = clean(referrer.hostname.toLowerCase(), 253);
        }
      }
      return touch;
    } catch (error) {
      return null;
    }
  }

  function hasAttributionSignal(touch) {
    if (!touch) return false;
    return (
      !!touch.referrer_host ||
      TEXT_KEYS.concat(CLICK_KEYS).some(function (key) {
        return !!touch[key];
      })
    );
  }

  function isPaidTouch(touch) {
    if (!touch) return false;
    if (
      CLICK_KEYS.some(function (key) {
        return !!touch[key];
      })
    )
      return true;
    var medium = clean(touch.utm_medium);
    return !!medium && PAID_MEDIA[medium.toLowerCase().replace(/[ -]+/g, "_")] === true;
  }

  function validTouch(touch, now) {
    if (!touch || typeof touch !== "object") return null;
    if (!isAlunirUrl(touch.landing_page)) return null;
    var captured = Date.parse(touch.captured_at);
    var expires = Date.parse(touch.expires_at);
    if (
      !Number.isFinite(captured) ||
      !Number.isFinite(expires) ||
      expires <= captured ||
      expires <= now
    )
      return null;
    var output = {
      captured_at: new Date(captured).toISOString(),
      expires_at: new Date(expires).toISOString(),
      landing_page: clean(touch.landing_page),
      referrer_host: clean(touch.referrer_host, 253),
    };
    TEXT_KEYS.concat(CLICK_KEYS).forEach(function (key) {
      var value = clean(touch[key]);
      if (value) output[key] = value;
    });
    return output;
  }

  function clear() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function read() {
    if (!marketingAllowed()) {
      clear();
      return null;
    }
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw || raw.length > 12000) return null;
      var stored = JSON.parse(raw);
      if (!stored || stored.version !== VERSION) {
        clear();
        return null;
      }
      var now = Date.now();
      var first = validTouch(stored.first_touch, now);
      var lastPaid = validTouch(stored.last_paid_touch, now);
      if (!first && !lastPaid) {
        clear();
        return null;
      }
      return buildRecord(first, lastPaid);
    } catch (error) {
      clear();
      return null;
    }
  }

  function buildRecord(first, lastPaid) {
    var expiries = [first, lastPaid].filter(Boolean).map(function (touch) {
      return Date.parse(touch.expires_at);
    });
    return {
      version: VERSION,
      first_touch: first || null,
      last_paid_touch: lastPaid || null,
      expires_at: new Date(Math.max.apply(Math, expiries)).toISOString(),
    };
  }

  function write(record) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (error) {}
  }

  function persistPendingTouch() {
    if (!marketingAllowed()) {
      clear();
      return null;
    }
    var existing = read();
    var first = existing && existing.first_touch;
    var lastPaid = existing && existing.last_paid_touch;
    if (hasAttributionSignal(pendingTouch) && !first) first = validTouch(pendingTouch, Date.now());
    if (isPaidTouch(pendingTouch)) lastPaid = validTouch(pendingTouch, Date.now());
    if (!first && !lastPaid) return null;
    var record = buildRecord(first, lastPaid);
    write(record);
    return record;
  }

  function get() {
    return persistPendingTouch() || read();
  }

  document.addEventListener("visitorConsentCollected", function (event) {
    if (event && event.detail && event.detail.marketingAllowed === false) clear();
    else if (marketingAllowed()) persistPendingTouch();
  });
  document.addEventListener("shopifyCustomerPrivacyApiLoaded", function () {
    if (marketingAllowed()) persistPendingTouch();
  });

  function retryMarketingConsent(remainingAttempts) {
    if (marketingAllowed()) {
      persistPendingTouch();
      return;
    }
    if (remainingAttempts <= 0 || typeof window.setTimeout !== "function") return;
    window.setTimeout(function () {
      retryMarketingConsent(remainingAttempts - 1);
    }, 250);
  }

  retryMarketingConsent(40);
  document.documentElement.setAttribute("data-alunir-attribution-version", String(VERSION));
  window.AlunirAttribution = Object.freeze({ get: get });
})();
